// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"3445b108c7666169ab39","293":"d3278340812ab7369653","518":"9f7fffc59a325afbbec2","779":"da8d6cd931cb54618c0a"}[chunkId] + ".js";
};